
import './App.css';
import Router from './components/routes';

function App() {
  return (
    <div className="App">
      <Router/>
    </div>
  );
}

export default App;
